import { createUseData } from "../../../common/hooks/create-use-data/create-use-data";
import { service } from "./submit-assessment.service";

export const useAssessment = createUseData(
    service.getAssessment
)